import { render, staticRenderFns } from "./ai-banner.vue?vue&type=template&id=4152739a&scoped=true"
import script from "./ai-banner.vue?vue&type=script&lang=js"
export * from "./ai-banner.vue?vue&type=script&lang=js"
import style0 from "./ai-banner.vue?vue&type=style&index=0&id=4152739a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4152739a",
  null
  
)

export default component.exports